<template>
  <div class="home">
    <div class="buttons">
      <button v-if="savedGame" class="restore-btn" @click="restoreSavedGame">
        {{ savedGame.label }} hervatten
      </button>

      <span class="new-game-label">Nieuw spel</span>
      <button class="start-btn" @click="requestStart('whist')" @keydown.enter.stop="requestStart('whist')">
        Kleurenwiezen
      </button>
      <button class="start-btn" @click="requestStart('boerenbridge')" @keydown.enter.stop="requestStart('boerenbridge')">
        Boerenbridge
      </button>

      <GameTransfer class="transfer-block" />
    </div>

    <ConfirmDialog
      v-if="pendingGame"
      title="Lopend spel wissen?"
      :body="`Er loopt nog een spel ${savedGame.label}. Een nieuw spel starten wist die voortgang.`"
      confirm-label="Nieuw spel"
      @confirm="start(pendingGame)"
      @cancel="pendingGame = null"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useGameStore } from '../../stores/game'
import { useBoerenbridgeStore } from '../../stores/boerenbridge'
import ConfirmDialog from '../shared/ConfirmDialog.vue'
import GameTransfer from '../shared/GameTransfer.vue'

export default {
  name: 'StartGame',
  components: { ConfirmDialog, GameTransfer },
  data() {
    return { pendingGame: null }
  },
  computed: {
    ...mapState(useGameStore, { hasSavedWhist: 'hasSavedGame' }),
    ...mapState(useBoerenbridgeStore, { hasSavedBoerenbridge: 'hasSavedGame' }),
    /** Er kan maar één spel tegelijk lopen. */
    savedGame() {
      if (this.hasSavedBoerenbridge) return { id: 'boerenbridge', label: 'Boerenbridge' }
      if (this.hasSavedWhist) return { id: 'whist', label: 'Kleurenwiezen' }
      return null
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    ...mapActions(useGameStore, ['startNewGame', 'restoreGame', 'resetGame']),
    ...mapActions(useBoerenbridgeStore, {
      startNewBoerenbridge: 'startNewGame',
      restoreBoerenbridge: 'restoreGame',
      resetBoerenbridge: 'resetGame'
    }),
    requestStart(gameId) {
      if (this.savedGame) {
        this.pendingGame = gameId
        return
      }
      this.start(gameId)
    },
    start(gameId) {
      this.pendingGame = null
      // Er loopt maar één spel tegelijk: het andere spel wordt gewist.
      if (gameId === 'boerenbridge') {
        this.resetGame()
        this.startNewBoerenbridge()
      } else {
        this.resetBoerenbridge()
        this.startNewGame()
      }
    },
    restoreSavedGame() {
      if (!this.savedGame) return
      this.savedGame.id === 'boerenbridge' ? this.restoreBoerenbridge() : this.restoreGame()
    },
    handleKeydown(e) {
      if (e.key !== 'Enter') return
      if (this.pendingGame) return this.start(this.pendingGame)
      if (this.savedGame) return this.restoreSavedGame()
      this.start('whist')
    }
  }
}
</script>

<style scoped>
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
  max-width: min(320px, 80%);
}

.new-game-label {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #2c3e50;
  opacity: 0.6;
}

.transfer-block {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #aac8aa;
}

.start-btn {
  width: 100%;
  padding: 1rem 2.5rem;
  font-size: 1.25rem;
  font-family: inherit;
  background-color: #2c3e50;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  touch-action: manipulation;
}

.restore-btn {
  width: 100%;
  padding: 1rem 2.5rem;
  font-size: 1.25rem;
  font-family: inherit;
  background: transparent;
  color: #2c3e50;
  border: 2px solid #2c3e50;
  border-radius: 8px;
  cursor: pointer;
  touch-action: manipulation;
}

.start-btn:active,
.restore-btn:active {
  opacity: 0.85;
}

@media (min-width: 600px) {
  .buttons {
    max-width: 360px;
  }

  .start-btn,
  .restore-btn {
    font-size: 1.4rem;
    padding: 1.15rem 3rem;
  }
}

@media (min-width: 1024px) {
  .start-btn,
  .restore-btn {
    font-size: 1.5rem;
    padding: 1.25rem 3.5rem;
  }

  .start-btn:hover {
    opacity: 0.9;
  }

  .restore-btn:hover {
    background: rgba(44, 62, 80, 0.05);
  }
}
</style>
